export const FORGOT_PASSWORD_ACTION = 'FORGOT_PASSWORD_ACTION';
export const FORGOT_PASSWORD_SUCCESS_ACTION = 'FORGOT_PASSWORD_SUCCESS_ACTION';
export const FORGOT_PASSWORD_FAILURE_ACTION = 'FORGOT_PASSWORD_FAILURE_ACTION';
